// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ui.css */

/* === Buttons === */

/* Green - Primary Actions (Execute/Run only) */
.btn-primary {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

/* Blue - Accent Actions (Confirm/Save) */
.btn-action-accent {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(33 138 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-action-accent:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 122 239 / var(--tw-bg-opacity, 1));
}

/* Light Gray - Secondary Actions (Data operations) */
.btn-secondary {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(216 216 216 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(174 185 204 / var(--tw-bg-opacity, 1));
}

/* Dark Gray - Utility Actions (Cancel/Close) */
.btn-utility {
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-utility:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 42 / var(--tw-bg-opacity, 1));
}

/* Ghost - Inline Actions (Edit) */
.btn-ghost {
  border-radius: 0.25rem;
  background-color: transparent;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(174 185 204 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-ghost:hover {
  background-color: rgb(255 255 255 / 0.05);
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

/* Ghost Danger - Inline Delete (subtle gray to red on hover) */
.btn-ghost-danger {
  border-radius: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(174 185 204 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-ghost-danger:hover {
  background-color: rgb(239 68 68 / 0.1);
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

/* Ghost Primary - Inline Actions (subtle gray to blue on hover) */
.btn-ghost-primary {
  border-radius: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(174 185 204 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-ghost-primary:hover {
  background-color: rgb(59 130 246 / 0.1);
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

/* Legacy styles for backward compatibility */
.btn-blue {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(33 138 255 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-blue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 122 239 / var(--tw-bg-opacity, 1));
}

.btn-red {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.btn-red:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.btn-export-primary {
  border-radius: 0.25rem;
  border-width: 1px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  background-color: #1f2937; /* gray-800 like tab buttons */
  color: #b0b0b0; /* text-secondary */
  border-color: #333;
}

.btn-export-primary:hover {
  background-color: #218aff; /* Blue on hover like tab buttons */
  color: #ffffff; /* White text on hover */
  border-color: #218aff;
}

.btn-export-secondary {
  border-radius: 0.25rem;
  border-width: 1px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  background-color: #1f2937; /* gray-800 like tab buttons */
  color: #b0b0b0; /* text-secondary */
  border-color: #333;
}

.btn-export-secondary:hover {
  background-color: #218aff; /* Blue on hover like tab buttons */
  color: #ffffff; /* White text on hover */
  border-color: #218aff;
}

/* === Typography === */
.heading-xl {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.heading-lg {
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

.text-error {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

/* === Cards & Containers === */
.card {
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

.card-hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.card-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(42 42 42 / var(--tw-bg-opacity, 1));
}

/* === Labels & Inputs === */
.label {
  margin-bottom: 0.25rem;
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

.input {
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 11 / var(--tw-bg-opacity, 1));
  padding: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

.filter-heading {
  margin-bottom: 0.25rem;
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

/* === Filters === */
.filters {
  position: relative;
  z-index: 100;
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 100%;
}

.filter-select {
  min-width: 200px;
  flex: 1 1;
}

/* === Utilities === */
.flex-responsive {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (min-width: 768px) {
  .flex-responsive {
    flex-direction: row;
  }
}

.container-wide {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 100%;
}

/* === Table === */
.table-container {
  position: relative;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 11 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  max-width: 100%;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
}

/* Scroll indicators */
.table-scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: auto; /* Enables vertical scrolling */
  flex: 1 1;
  min-height: 0; /* Critical: allows flex child to shrink below content size */
  scrollbar-width: thin;
  scrollbar-color: #15803d #212121;
}

.table-scroll-container::-webkit-scrollbar {
  height: 8px;
}

.table-scroll-container::-webkit-scrollbar-track {
  background: #212121;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb {
  background: #15803d;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #22c55e;
}

/* Shadow indicators for scroll */
.table-scroll-shadow-left {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(to right, rgba(0,0,0,0.15), transparent);
  pointer-events: none;
  z-index: 10;
}

.table-scroll-shadow-right {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 20px;
  background: linear-gradient(to left, rgba(0,0,0,0.15), transparent);
  pointer-events: none;
  z-index: 10;
}

.table {
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.table-header {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  position: sticky;
  top: 0;
  z-index: 20;
  background-color: #0B0B0B;
}

.table-header-cell {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  background-color: #0B0B0B;
  color: #218aff;
  transition: color 0.2s ease;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.3;
  position: relative;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: manual;
  min-width: 80px;
  max-width: 120px;
  vertical-align: middle;
}

.table-header-cell:hover {
  color: #fdfdfd;
}

/* Sticky columns for essential data */
.table-header-cell-sticky {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: center;
  background-color: #0B0B0B;
  color: #218aff;
  transition: color 0.2s ease;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.7rem;
  line-height: 1.2;
  position: sticky;
  z-index: 25;
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.2);
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  vertical-align: middle;
}

.table-header-cell-sticky:hover {
  color: #fdfdfd;
}

/* Sticky-0: Action buttons column (★ / + / -) */
.table-header-cell-sticky-0 {
  left: 0;
  width: 52px;
  min-width: 52px;
  max-width: 52px;
  background-color: #0B0B0B;
  cursor: default;
}

.table-header-cell-sticky-1 {
  left: 52px;
  width: 65px;
  min-width: 65px;
  max-width: 65px;
  background-color: #0B0B0B;
}

.table-header-cell-sticky-2 {
  left: 117px;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  background-color: #0B0B0B;
}

.table-header-cell-sticky-3 {
  left: 187px;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  background-color: #0B0B0B;
}

.table-header-cell-sticky-4 {
  left: 247px;
  width: 130px;
  min-width: 130px;
  max-width: 130px;
  background-color: #0B0B0B;
}

.table-header-cell-sticky-5 {
  left: 377px;
  width: 90px;
  min-width: 90px;
  max-width: 90px;
  background-color: #0B0B0B;
}

.table-header-cell-sticky-6 {
  left: 467px;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  background-color: #0B0B0B;
}

.table-cell {
  white-space: nowrap;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  min-width: 80px;
}

.table-cell-sticky {
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  position: sticky;
  z-index: 15;
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.15);
}

/* Sticky-0: Action buttons column (★ / + / -) */
.table-cell-sticky-0 {
  left: 0;
  width: 52px;
  min-width: 52px;
  max-width: 52px;
  background-color: #0B0B0B;
}

.table-cell-sticky-1 {
  left: 52px;
  width: 65px;
  min-width: 65px;
  max-width: 65px;
  background-color: #0B0B0B; /* Explicit opaque background */
}

.table-cell-sticky-2 {
  left: 117px;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  background-color: #0B0B0B; /* Explicit opaque background */
}

.table-cell-sticky-3 {
  left: 187px;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  background-color: #0B0B0B; /* Explicit opaque background */
}

.table-cell-sticky-4 {
  left: 247px;
  width: 130px;
  min-width: 130px;
  max-width: 130px;
  background-color: #0B0B0B; /* Explicit opaque background */
}

.table-cell-sticky-5 {
  left: 377px;
  width: 90px;
  min-width: 90px;
  max-width: 90px;
  background-color: #0B0B0B; /* Explicit opaque background */
}

.table-cell-sticky-6 {
  left: 467px;
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  background-color: #0B0B0B; /* Explicit opaque background */
  box-shadow: 6px 0 12px rgba(0, 0, 0, 0.3); /* Stronger shadow for last sticky column */
}

/* Fix background for even/odd rows - fully opaque */
.table-row-even .table-cell-sticky-0,
.table-row-even .table-cell-sticky-1,
.table-row-even .table-cell-sticky-2,
.table-row-even .table-cell-sticky-3,
.table-row-even .table-cell-sticky-4,
.table-row-even .table-cell-sticky-5,
.table-row-even .table-cell-sticky-6 {
  background-color: #1E1E1E !important; /* Fully opaque surface color for even rows */
}

.table-row-odd .table-cell-sticky-0,
.table-row-odd .table-cell-sticky-1,
.table-row-odd .table-cell-sticky-2,
.table-row-odd .table-cell-sticky-3,
.table-row-odd .table-cell-sticky-4,
.table-row-odd .table-cell-sticky-5,
.table-row-odd .table-cell-sticky-6 {
  background-color: #0B0B0B !important; /* Fully opaque background color for odd rows */
}

/* Ensure sticky cells maintain background on hover */
.table-row-even:hover .table-cell-sticky-0,
.table-row-even:hover .table-cell-sticky-1,
.table-row-even:hover .table-cell-sticky-2,
.table-row-even:hover .table-cell-sticky-3,
.table-row-even:hover .table-cell-sticky-4,
.table-row-even:hover .table-cell-sticky-5,
.table-row-even:hover .table-cell-sticky-6 {
  background-color: #1a3526 !important; /* Subtle green tint on surface color */
}

.table-row-odd:hover .table-cell-sticky-0,
.table-row-odd:hover .table-cell-sticky-1,
.table-row-odd:hover .table-cell-sticky-2,
.table-row-odd:hover .table-cell-sticky-3,
.table-row-odd:hover .table-cell-sticky-4,
.table-row-odd:hover .table-cell-sticky-5,
.table-row-odd:hover .table-cell-sticky-6 {
  background-color: #0f2419 !important; /* Subtle green tint on background color */
}

/* Regular row hover with same green tint */
.table-row-even:hover {
  background-color: #1a3526 !important;
}

.table-row-odd:hover {
  background-color: #0f2419 !important;
}

/* Favorited row subtle accent */
.table-row-favorited {
  box-shadow: inset 3px 0 0 0 #facc15;
}

/* Number formatting */
.table-cell-number {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.table-cell-positive {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.table-cell-negative {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.table-row-even {
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  background-color: rgb(33 33 33 / 0.5);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.table-row-odd {
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(174 185 204 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 11 / var(--tw-bg-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.table-row-hover:hover {
  background-color: rgb(33 138 255 / 0.2);
}

.table-cell {
  white-space: nowrap;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

/* === Tabs === */
.tab-button {
  border-radius: 0.25rem;
  border-width: 1px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  background-color: #1f2937; /* gray-800 like Add to Queue button */
  color: #b0b0b0; /* text-secondary */
  border-color: #333;
}

.tab-selected {
  background-color: #218aff !important; /* Blue like active/hover state */
  color: #ffffff !important; /* White text */
  border-color: #218aff !important;
}

.tab-unselected {
  background-color: #1f2937; /* gray-800 default */
  color: #b0b0b0; /* text-secondary */
  border-color: #333;
}

.tab-unselected:hover {
  background-color: #218aff; /* Blue on hover */
  color: #ffffff; /* White text on hover */
  border-color: #218aff;
}


/* === Spotify Theme Additions === */

.btn-green {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 185 84 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.btn-green:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 215 96 / var(--tw-bg-opacity, 1));
}

.btn-dark {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.btn-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(85 85 85 / var(--tw-bg-opacity, 1));
}

.btn-danger {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 76 76 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.btn-danger:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 85 85 / var(--tw-bg-opacity, 1));
}

.card-dark {
  border-radius: 0.75rem;
  border-width: 1px;
  border-color: rgb(29 185 84 / 0.4);
  --tw-bg-opacity: 1;
  background-color: rgb(40 40 40 / var(--tw-bg-opacity, 1));
  padding: 1rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.card-dark:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.modal-dark {
  border-radius: 0.75rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(29 185 84 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 18 / var(--tw-bg-opacity, 1));
  padding: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* === Animations === */
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}

/* === Share Preview Modal === */

.share-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.share-modal-content {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  max-width: 900px;
  max-height: 90vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.share-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #333;
}

.share-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.share-modal-close {
  background: transparent;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.share-modal-close:hover {
  color: #fff;
  background: #333;
}

.share-preview-wrapper {
  flex: 1 1;
  overflow: auto;
  padding: 20px;
  background: #121212;
}

/* Capture Container - The actual image that gets captured */
.share-capture-container {
  background: #0a0a0a;
  padding: 20px;
  border-radius: 8px;
  min-width: auto;
}

/* Simulation Settings Header */
.share-settings-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #218aff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
  text-align: center;
}

.share-settings-title {
  font-size: 11px;
  font-weight: 700;
  color: #218aff;
  letter-spacing: 1.5px;
  margin-bottom: 6px;
}

.share-settings-value {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

/* Share Modal - Slider Visualization */
.share-sliders-preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
}

.share-slider-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.share-slider-label {
  font-size: 11px;
  color: #888;
  min-width: 100px;
  text-transform: uppercase;
  text-align: left;
}

.share-slider-track {
  flex: 1 1;
  height: 6px;
  background: #333;
  border-radius: 3px;
  position: relative;
}

.share-slider-fill {
  height: 100%;
  background: linear-gradient(90deg, #218aff, #1a6bc7);
  border-radius: 3px;
}

.share-slider-thumb {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  background: #218aff;
  border: 2px solid #0a0a0a;
  border-radius: 50%;
}

.share-slider-value {
  font-size: 12px;
  font-weight: 600;
  color: #218aff;
  min-width: 100px;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.share-slider-date {
  font-size: 10px;
  color: #666;
  font-weight: 400;
}

/* Share Table */
.share-table-wrapper {
  overflow-x: auto;
  margin-bottom: 20px;
}

.share-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.share-table-header {
  background: #1a1a1a;
  color: #888;
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 8px 6px;
  text-align: center;
  border-bottom: 2px solid #333;
  white-space: normal;
  min-width: 60px;
  max-width: 90px;
  line-height: 1.3;
}

.share-table-cell {
  padding: 8px 6px;
  color: #e0e0e0;
  white-space: nowrap;
  border-bottom: 1px solid #222;
  text-align: center;
  font-size: 12px;
}

.share-row-even {
  background: #0f0f0f;
}

.share-row-odd {
  background: #141414;
}

.share-value-positive {
  color: #10b981 !important;
  font-weight: 600;
}

.share-value-negative {
  color: #ef4444 !important;
  font-weight: 600;
}

.share-table-truncated {
  text-align: center;
  color: #666;
  font-size: 12px;
  padding: 12px;
  border-top: 1px solid #222;
}

/* Grouped header band above scenario columns (heatmap-mode share) */
.share-table-header-group {
  background: #1a1a1a;
  color: #888;
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 6px 6px;
  text-align: center;
  border-bottom: 1px solid #333;
}

.share-table-header-group-emphasis {
  color: #218aff;
  border-bottom-color: #218aff;
}

/* Multi-line Contract cell (overrides nowrap) */
.share-table-cell-multiline {
  white-space: normal;
  text-align: left;
  padding: 6px 8px;
  line-height: 1.25;
}

.share-contract-line1 {
  font-weight: 600;
  color: #ffffff;
  font-size: 12px;
}

.share-contract-line2 {
  color: #b0b0b0;
  font-size: 11px;
  margin-top: 1px;
}

/* Subtitle under SIMULATION SETTINGS card (heatmap-mode share) */
.share-settings-subtitle {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #2a2a3e;
  font-size: 11px;
  color: #a0a0a0;
  text-align: center;
  line-height: 1.4;
}

.share-settings-subtitle strong {
  color: #ffffff;
  font-weight: 600;
}

.share-settings-subtitle > div + div {
  margin-top: 4px;
}

/* Branding Footer */
.share-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #333;
}

.share-footer-text {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.share-footer-brand {
  font-size: 18px;
  font-weight: 700;
  color: #218aff;
  letter-spacing: 0.5px;
}

/* Modal Action Buttons */
.share-modal-actions {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #333;
  background: #1a1a1a;
}

.share-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.share-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.share-btn-primary {
  background: #218aff;
  color: #ffffff;
}

.share-btn-primary:hover:not(:disabled) {
  background: #1a73e8;
}

.share-btn-secondary {
  background: #333;
  color: #ffffff;
  border: 1px solid #444;
}

.share-btn-secondary:hover:not(:disabled) {
  background: #444;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ui.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX,oBAAoB;;AAEpB,+CAA+C;AAE7C;EAAA,sBAAgH;EAAhH,kBAAgH;EAAhH,2DAAgH;EAAhH,oBAAgH;EAAhH,qBAAgH;EAAhH,mBAAgH;EAAhH,sBAAgH;EAAhH,gBAAgH;EAAhH,oBAAgH;EAAhH,6CAAgH;EAAhH,+FAAgH;EAAhH,wDAAgH;EAAhH;AAAgH;AAAhH;EAAA,kBAAgH;EAAhH;AAAgH;;AAGlH,yCAAyC;AAEvC;EAAA,sBAAiH;EAAjH,kBAAiH;EAAjH,2DAAiH;EAAjH,oBAAiH;EAAjH,qBAAiH;EAAjH,mBAAiH;EAAjH,sBAAiH;EAAjH,gBAAiH;EAAjH,oBAAiH;EAAjH,mDAAiH;EAAjH,+FAAiH;EAAjH,wDAAiH;EAAjH;AAAiH;AAAjH;EAAA,kBAAiH;EAAjH;AAAiH;;AAGnH,qDAAqD;AAEnD;EAAA,sBAAgI;EAAhI,kBAAgI;EAAhI,4DAAgI;EAAhI,kBAAgI;EAAhI,mBAAgI;EAAhI,mBAAgI;EAAhI,sBAAgI;EAAhI,gBAAgI;EAAhI,oBAAgI;EAAhI,gDAAgI;EAAhI,+FAAgI;EAAhI,wDAAgI;EAAhI;AAAgI;AAAhI;EAAA,kBAAgI;EAAhI;AAAgI;;AAGlI,+CAA+C;AAE7C;EAAA,sBAAuI;EAAvI,iBAAuI;EAAvI,sBAAuI;EAAvI,4DAAuI;EAAvI,kBAAuI;EAAvI,yDAAuI;EAAvI,kBAAuI;EAAvI,mBAAuI;EAAvI,mBAAuI;EAAvI,sBAAuI;EAAvI,oBAAuI;EAAvI,mDAAuI;EAAvI,+FAAuI;EAAvI,wDAAuI;EAAvI;AAAuI;AAAvI;EAAA,kBAAuI;EAAvI;AAAuI;;AAGzI,kCAAkC;AAEhC;EAAA,sBAAmI;EAAnI,6BAAmI;EAAnI,qBAAmI;EAAnI,sBAAmI;EAAnI,oBAAmI;EAAnI,uBAAmI;EAAnI,oBAAmI;EAAnI,mDAAmI;EAAnI,+FAAmI;EAAnI,wDAAmI;EAAnI;AAAmI;AAAnI;EAAA,yCAAmI;EAAnI,oBAAmI;EAAnI;AAAmI;;AAGrI,+DAA+D;AAE7D;EAAA,sBAA2H;EAA3H,qBAA2H;EAA3H,sBAA2H;EAA3H,oBAA2H;EAA3H,uBAA2H;EAA3H,kBAA2H;EAA3H,iBAA2H;EAA3H,oBAA2H;EAA3H,mDAA2H;EAA3H,+FAA2H;EAA3H,wDAA2H;EAA3H;AAA2H;AAA3H;EAAA,sCAA2H;EAA3H,oBAA2H;EAA3H;AAA2H;;AAG7H,kEAAkE;AAEhE;EAAA,sBAA6H;EAA7H,qBAA6H;EAA7H,sBAA6H;EAA7H,oBAA6H;EAA7H,uBAA6H;EAA7H,kBAA6H;EAA7H,iBAA6H;EAA7H,oBAA6H;EAA7H,mDAA6H;EAA7H,+FAA6H;EAA7H,wDAA6H;EAA7H;AAA6H;AAA7H;EAAA,uCAA6H;EAA7H,oBAA6H;EAA7H;AAA6H;;AAG/H,6CAA6C;AAE3C;EAAA,sBAA2G;EAA3G,kBAA2G;EAA3G,2DAA2G;EAA3G,qBAA2G;EAA3G,sBAA2G;EAA3G,oBAA2G;EAA3G,uBAA2G;EAA3G,mBAA2G;EAA3G,oBAA2G;EAA3G,oBAA2G;EAA3G,mDAA2G;EAA3G,+FAA2G;EAA3G,wDAA2G;EAA3G;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G;AAA2G;;AAI3G;EAAA,sBAAsG;EAAtG,kBAAsG;EAAtG,0DAAsG;EAAtG,qBAAsG;EAAtG,sBAAsG;EAAtG,oBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,oBAAsG;EAAtG,oBAAsG;EAAtG,mDAAsG;EAAtG,+FAAsG;EAAtG,wDAAsG;EAAtG;AAAsG;;AAAtG;EAAA,kBAAsG;EAAtG;AAAsG;;AAItG;EAAA,sBAA+E;EAA/E,iBAA+E;EAA/E,oBAA+E;EAA/E,uBAA+E;EAA/E,qBAA+E;EAA/E,sBAA+E;EAA/E,mBAA+E;EAA/E,oBAA+E;EAA/E,gBAA+E;EAA/E,wBAA+E;EAA/E,wDAA+E;EAA/E,0BAA+E;EAC/E,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,EAAE,mBAAmB;EACnC;AAH+E;;AAMjF;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,cAAc,EAAE,wBAAwB;EACxC,qBAAqB;AACvB;;AAGE;EAAA,sBAA+E;EAA/E,iBAA+E;EAA/E,oBAA+E;EAA/E,uBAA+E;EAA/E,qBAA+E;EAA/E,sBAA+E;EAA/E,mBAA+E;EAA/E,oBAA+E;EAA/E,gBAA+E;EAA/E,wBAA+E;EAA/E,wDAA+E;EAA/E,0BAA+E;EAC/E,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,EAAE,mBAAmB;EACnC;AAH+E;;AAMjF;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,cAAc,EAAE,wBAAwB;EACxC,qBAAqB;AACvB;;AAEA,uBAAuB;AAErB;EAAA,qBAA2C;EAA3C,iBAA2C;EAA3C,iBAA2C;EAA3C,gBAA2C;EAA3C,oBAA2C;EAA3C;AAA2C;;AAI3C;EAAA,sBAA2C;EAA3C,mBAA2C;EAA3C,oBAA2C;EAA3C,gBAA2C;EAA3C,oBAA2C;EAA3C;AAA2C;;AAI3C;EAAA,oBAAmB;EAAnB;AAAmB;;AAGrB,+BAA+B;AAE7B;EAAA,uBAAoD;EAApD,iBAAoD;EAApD,sBAAoD;EAApD,4DAAoD;EAApD,kBAAoD;EAApD,yDAAoD;EAApD;AAAoD;;AAIpD;EAAA,0CAA8C;EAA9C,uDAA8C;EAA9C,uGAA8C;EAA9C,wJAA8C;EAA9C,wDAA8C;EAA9C;AAA8C;;AAA9C;EAAA,kBAA8C;EAA9C;AAA8C;;AAGhD,4BAA4B;AAE1B;EAAA,sBAAmC;EAAnC,cAAmC;EAAnC,mBAAmC;EAAnC,oBAAmC;EAAnC,oBAAmC;EAAnC;AAAmC;;AAInC;EAAA,WAAqE;EAArE,sBAAqE;EAArE,iBAAqE;EAArE,sBAAqE;EAArE,4DAAqE;EAArE,kBAAqE;EAArE,yDAAqE;EAArE,eAAqE;EAArE,oBAAqE;EAArE;AAAqE;;AAIrE;EAAA,sBAA+C;EAA/C,cAA+C;EAA/C,mBAA+C;EAA/C,oBAA+C;EAA/C,gBAA+C;EAA/C,oBAA+C;EAA/C;AAA+C;;AAGjD,oBAAoB;AAElB;EAAA,kBAAmC;EAAnC,YAAmC;EAAnC,gBAAmC;EAAnC,mBAAmC;EAAnC;AAAmC;;AAInC;EAAA,gBAA2B;EAA3B;AAA2B;;AAG7B,sBAAsB;AAEpB;EAAA,aAAsC;EAAtC,sBAAsC;EAAtC;AAAsC;AAAtC;EAAA;IAAA;EAAsC;AAAA;;AAItC;EAAA,iBAAgC;EAAhC,kBAAgC;EAAhC,WAAgC;EAAhC;AAAgC;;AAGlC,kBAAkB;AAEhB;EAAA,kBAAmE;EAAnE,uBAAmE;EAAnE,iBAAmE;EAAnE,sBAAmE;EAAnE,4DAAmE;EAAnE,kBAAmE;EAAnE,yDAAmE;EAAnE,0EAAmE;EAAnE,8FAAmE;EAAnE,uGAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb;AAJmE;;AAOrE,sBAAsB;AAEpB;EAAA,kBAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE,+BAA+B;EACjD,SAAO;EACP,aAAa,EAAE,6DAA6D;EAC5E,qBAAqB;EACrB;AANe;;AASjB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mBAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mBAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,WAAW;EACX,oEAAoE;EACpE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,WAAW;EACX,mEAAmE;EACnE,oBAAoB;EACpB,WAAW;AACb;;AAGE;EAAA,gBAAwB;EAAxB,mBAAwB;EAAxB,oBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB;AAJwB;;AAQxB;EAAA,wBAA4B;EAA5B,sBAA4B;EAA5B,4DAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX;AAJ4B;;AAQ5B;EAAA,eAAoE;EAApE,yBAAoE;UAApE,iBAAoE;EAApE,qBAAoE;EAApE,sBAAoE;EAApE,oBAAoE;EAApE,uBAAoE;EAApE,kBAAoE;EACpE,yBAA4C;EAC5C,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB;AAfoE;;AAkBtE;EACE,cAAc;AAChB;;AAEA,sCAAsC;AAEpC;EAAA,eAAoE;EAApE,yBAAoE;UAApE,iBAAoE;EAApE,oBAAoE;EAApE,qBAAoE;EAApE,oBAAoE;EAApE,uBAAoE;EAApE,kBAAoE;EACpE,yBAA4C;EAC5C,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB;AAdoE;;AAiBtE;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAA4C;AAC9C;;AAGE;EAAA,mBAA0C;EAA1C,qBAA0C;EAA1C,sBAA0C;EAA1C,mBAA0C;EAA1C,sBAA0C;EAA1C,mBAA0C;EAA1C,oBAA0C;EAC1C;AAD0C;;AAK1C;EAAA,mBAA0C;EAA1C,oBAA0C;EAA1C,qBAA0C;EAA1C,mBAA0C;EAA1C,sBAA0C;EAA1C,mBAA0C;EAA1C,oBAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX;AAH0C;;AAM5C,gDAAgD;AAChD;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE,+BAA+B;EAC1D,yCAAyC,EAAE,2CAA2C;AACxF;;AAEA,oDAAoD;AACpD;;;;;;;EAOE,oCAAoC,EAAE,6CAA6C;AACrF;;AAEA;;;;;;;EAOE,oCAAoC,EAAE,+CAA+C;AACvF;;AAEA,qDAAqD;AACrD;;;;;;;EAOE,oCAAoC,EAAE,uCAAuC;AAC/E;;AAEA;;;;;;;EAOE,oCAAoC,EAAE,0CAA0C;AAClF;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AAEpB;EAAA,iBAAiB;EACjB;AADiB;;AAKjB;EAAA,oBAAqB;EAArB;AAAqB;;AAIrB;EAAA,oBAAmB;EAAnB;AAAmB;;AAInB;EAAA,qBAAqD;EAArD,sBAAqD;EAArD,4DAAqD;EAArD,qCAAqD;EAArD,wJAAqD;EAArD,wDAAqD;EAArD;AAAqD;;AAIrD;EAAA,qBAAqD;EAArD,sBAAqD;EAArD,4DAAqD;EAArD,kBAAqD;EAArD,yDAAqD;EAArD,wJAAqD;EAArD,wDAAqD;EAArD;AAAqD;;AAIrD;EAAA;AAAyB;;AAIzB;EAAA,mBAA4C;EAA5C,kBAA4C;EAA5C,mBAA4C;EAA5C,mBAA4C;EAA5C,sBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;;AAG9C,iBAAiB;AAEf;EAAA,sBAA+E;EAA/E,iBAA+E;EAA/E,qBAA+E;EAA/E,sBAA+E;EAA/E,oBAA+E;EAA/E,uBAA+E;EAA/E,mBAA+E;EAA/E,oBAA+E;EAA/E,gBAA+E;EAA/E,wBAA+E;EAA/E,wDAA+E;EAA/E,0BAA+E;EAC/E,yBAAyB,EAAE,sCAAsC;EACjE,cAAc,EAAE,mBAAmB;EACnC;AAH+E;;AAMjF;EACE,oCAAoC,EAAE,iCAAiC;EACvE,yBAAyB,EAAE,eAAe;EAC1C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,cAAc,EAAE,mBAAmB;EACnC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,cAAc,EAAE,wBAAwB;EACxC,qBAAqB;AACvB;;;AAGA,oCAAoC;;AAGlC;EAAA,sBAA2E;EAA3E,kBAA2E;EAA3E,0DAA2E;EAA3E,qBAA2E;EAA3E,sBAA2E;EAA3E,oBAA2E;EAA3E,uBAA2E;EAA3E,kBAA2E;EAA3E,iBAA2E;EAA3E,oBAA2E;EAA3E;AAA2E;;AAA3E;EAAA,kBAA2E;EAA3E;AAA2E;;AAI3E;EAAA,sBAAwE;EAAxE,kBAAwE;EAAxE,yDAAwE;EAAxE,qBAAwE;EAAxE,sBAAwE;EAAxE,oBAAwE;EAAxE,uBAAwE;EAAxE,kBAAwE;EAAxE,iBAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;;AAAxE;EAAA,kBAAwE;EAAxE;AAAwE;;AAIxE;EAAA,sBAA2E;EAA3E,kBAA2E;EAA3E,0DAA2E;EAA3E,qBAA2E;EAA3E,sBAA2E;EAA3E,oBAA2E;EAA3E,uBAA2E;EAA3E,kBAA2E;EAA3E,iBAA2E;EAA3E,oBAA2E;EAA3E;AAA2E;;AAA3E;EAAA,kBAA2E;EAA3E;AAA2E;;AAI3E;EAAA,sBAAoH;EAApH,iBAAoH;EAApH,kCAAoH;EAApH,kBAAoH;EAApH,yDAAoH;EAApH,aAAoH;EAApH,oBAAoH;EAApH,mDAAoH;EAApH,6EAAoH;EAApH,iGAAoH;EAApH,uGAAoH;EAApH,+BAAoH;EAApH,wDAAoH;EAApH;AAAoH;;AAApH;EAAA,+EAAoH;EAApH,mGAAoH;EAApH;AAAoH;;AAIpH;EAAA,sBAA+E;EAA/E,iBAA+E;EAA/E,sBAA+E;EAA/E,0DAA+E;EAA/E,kBAA+E;EAA/E,yDAA+E;EAA/E,eAA+E;EAA/E,oBAA+E;EAA/E,mDAA+E;EAA/E,gFAA+E;EAA/E,oGAA+E;EAA/E;AAA+E;;AAGjF,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gCAAgC;;AAEhC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* ui.css */\n\n/* === Buttons === */\n\n/* Green - Primary Actions (Execute/Run only) */\n.btn-primary {\n  @apply bg-green-400 hover:bg-green-500 text-black px-6 py-2 rounded font-semibold transition-colors duration-200;\n}\n\n/* Blue - Accent Actions (Confirm/Save) */\n.btn-action-accent {\n  @apply bg-brand-blue hover:bg-[#1a7aef] text-white px-6 py-2 rounded font-semibold transition-colors duration-200;\n}\n\n/* Light Gray - Secondary Actions (Data operations) */\n.btn-secondary {\n  @apply bg-brand-gray-light hover:bg-brand-gray-blue text-brand-dark px-4 py-2 rounded font-medium transition-colors duration-200;\n}\n\n/* Dark Gray - Utility Actions (Cancel/Close) */\n.btn-utility {\n  @apply bg-brand-dark hover:bg-[#2a2a2a] text-brand-white border border-brand-gray-blue px-4 py-2 rounded transition-colors duration-200;\n}\n\n/* Ghost - Inline Actions (Edit) */\n.btn-ghost {\n  @apply text-brand-gray-blue hover:text-brand-white bg-transparent hover:bg-white/5 px-3 py-1 rounded transition-colors duration-200;\n}\n\n/* Ghost Danger - Inline Delete (subtle gray to red on hover) */\n.btn-ghost-danger {\n  @apply text-brand-gray-blue hover:text-red-500 hover:bg-red-500/10 px-3 py-1 text-xs rounded transition-colors duration-200;\n}\n\n/* Ghost Primary - Inline Actions (subtle gray to blue on hover) */\n.btn-ghost-primary {\n  @apply text-brand-gray-blue hover:text-blue-400 hover:bg-blue-500/10 px-3 py-1 text-xs rounded transition-colors duration-200;\n}\n\n/* Legacy styles for backward compatibility */\n.btn-blue {\n  @apply bg-brand-blue hover:bg-[#1a7aef] text-white px-3 py-1 text-sm rounded transition-colors duration-200;\n}\n\n.btn-red {\n  @apply bg-red-600 hover:bg-red-500 text-white px-3 py-1 text-sm rounded transition-colors duration-200;\n}\n\n.btn-export-primary {\n  @apply font-medium text-sm py-1 px-3 rounded transition-all duration-200 border;\n  background-color: #1f2937; /* gray-800 like tab buttons */\n  color: #b0b0b0; /* text-secondary */\n  border-color: #333;\n}\n\n.btn-export-primary:hover {\n  background-color: #218aff; /* Blue on hover like tab buttons */\n  color: #ffffff; /* White text on hover */\n  border-color: #218aff;\n}\n\n.btn-export-secondary {\n  @apply font-medium text-sm py-1 px-3 rounded transition-all duration-200 border;\n  background-color: #1f2937; /* gray-800 like tab buttons */\n  color: #b0b0b0; /* text-secondary */\n  border-color: #333;\n}\n\n.btn-export-secondary:hover {\n  background-color: #218aff; /* Blue on hover like tab buttons */\n  color: #ffffff; /* White text on hover */\n  border-color: #218aff;\n}\n\n/* === Typography === */\n.heading-xl {\n  @apply text-2xl font-bold text-primary mb-6;\n}\n\n.heading-lg {\n  @apply text-lg font-semibold mb-3 text-text;\n}\n\n.text-error {\n  @apply text-red-400;\n}\n\n/* === Cards & Containers === */\n.card {\n  @apply p-4 border border-muted rounded-md bg-surface;\n}\n\n.card-hover {\n  @apply hover:bg-[#2A2A2A] shadow-sm transition;\n}\n\n/* === Labels & Inputs === */\n.label {\n  @apply block text-sm mb-1 text-text;\n}\n\n.input {\n  @apply w-full p-2 rounded bg-background border border-muted text-text;\n}\n\n.filter-heading {\n  @apply block text-sm font-medium text-text mb-1;\n}\n\n/* === Filters === */\n.filters {\n  @apply my-4 w-full z-[100] relative;\n}\n\n.filter-select {\n  @apply flex-1 min-w-[200px];\n}\n\n/* === Utilities === */\n.flex-responsive {\n  @apply flex flex-col md:flex-row gap-4;\n}\n\n.container-wide {\n  @apply w-full max-w-full mx-auto;\n}\n\n/* === Table === */\n.table-container {\n  @apply relative rounded-md shadow border border-muted bg-background;\n  max-width: 100%;\n  max-height: 75vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Scroll indicators */\n.table-scroll-container {\n  @apply relative;\n  overflow-x: auto;\n  overflow-y: auto; /* Enables vertical scrolling */\n  flex: 1;\n  min-height: 0; /* Critical: allows flex child to shrink below content size */\n  scrollbar-width: thin;\n  scrollbar-color: theme('colors.primary') theme('colors.surface');\n}\n\n.table-scroll-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-scroll-container::-webkit-scrollbar-track {\n  background: theme('colors.surface');\n  border-radius: 4px;\n}\n\n.table-scroll-container::-webkit-scrollbar-thumb {\n  background: theme('colors.primary');\n  border-radius: 4px;\n}\n\n.table-scroll-container::-webkit-scrollbar-thumb:hover {\n  background: theme('colors.green.500');\n}\n\n/* Shadow indicators for scroll */\n.table-scroll-shadow-left {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  background: linear-gradient(to right, rgba(0,0,0,0.15), transparent);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.table-scroll-shadow-right {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  background: linear-gradient(to left, rgba(0,0,0,0.15), transparent);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.table {\n  @apply text-sm text-left;\n  width: max-content;\n  min-width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.table-header {\n  @apply border-b border-muted;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  background-color: theme('colors.background');\n}\n\n.table-header-cell {\n  @apply px-3 py-3 text-center align-middle cursor-pointer select-none;\n  background-color: theme('colors.background');\n  color: #218aff;\n  transition: color 0.2s ease;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 0.75rem;\n  line-height: 1.3;\n  position: relative;\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: break-word;\n  hyphens: manual;\n  min-width: 80px;\n  max-width: 120px;\n  vertical-align: middle;\n}\n\n.table-header-cell:hover {\n  color: #fdfdfd;\n}\n\n/* Sticky columns for essential data */\n.table-header-cell-sticky {\n  @apply px-2 py-3 text-center align-middle cursor-pointer select-none;\n  background-color: theme('colors.background');\n  color: #218aff;\n  transition: color 0.2s ease;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 0.7rem;\n  line-height: 1.2;\n  position: sticky;\n  z-index: 25;\n  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.2);\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: break-word;\n  vertical-align: middle;\n}\n\n.table-header-cell-sticky:hover {\n  color: #fdfdfd;\n}\n\n/* Sticky-0: Action buttons column (★ / + / -) */\n.table-header-cell-sticky-0 {\n  left: 0;\n  width: 52px;\n  min-width: 52px;\n  max-width: 52px;\n  background-color: theme('colors.background');\n  cursor: default;\n}\n\n.table-header-cell-sticky-1 {\n  left: 52px;\n  width: 65px;\n  min-width: 65px;\n  max-width: 65px;\n  background-color: theme('colors.background');\n}\n\n.table-header-cell-sticky-2 {\n  left: 117px;\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  background-color: theme('colors.background');\n}\n\n.table-header-cell-sticky-3 {\n  left: 187px;\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n  background-color: theme('colors.background');\n}\n\n.table-header-cell-sticky-4 {\n  left: 247px;\n  width: 130px;\n  min-width: 130px;\n  max-width: 130px;\n  background-color: theme('colors.background');\n}\n\n.table-header-cell-sticky-5 {\n  left: 377px;\n  width: 90px;\n  min-width: 90px;\n  max-width: 90px;\n  background-color: theme('colors.background');\n}\n\n.table-header-cell-sticky-6 {\n  left: 467px;\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  background-color: theme('colors.background');\n}\n\n.table-cell {\n  @apply px-3 py-2 text-sm whitespace-nowrap;\n  min-width: 80px;\n}\n\n.table-cell-sticky {\n  @apply px-2 py-2 text-sm whitespace-nowrap;\n  position: sticky;\n  z-index: 15;\n  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Sticky-0: Action buttons column (★ / + / -) */\n.table-cell-sticky-0 {\n  left: 0;\n  width: 52px;\n  min-width: 52px;\n  max-width: 52px;\n  background-color: #0B0B0B;\n}\n\n.table-cell-sticky-1 {\n  left: 52px;\n  width: 65px;\n  min-width: 65px;\n  max-width: 65px;\n  background-color: #0B0B0B; /* Explicit opaque background */\n}\n\n.table-cell-sticky-2 {\n  left: 117px;\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  background-color: #0B0B0B; /* Explicit opaque background */\n}\n\n.table-cell-sticky-3 {\n  left: 187px;\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n  background-color: #0B0B0B; /* Explicit opaque background */\n}\n\n.table-cell-sticky-4 {\n  left: 247px;\n  width: 130px;\n  min-width: 130px;\n  max-width: 130px;\n  background-color: #0B0B0B; /* Explicit opaque background */\n}\n\n.table-cell-sticky-5 {\n  left: 377px;\n  width: 90px;\n  min-width: 90px;\n  max-width: 90px;\n  background-color: #0B0B0B; /* Explicit opaque background */\n}\n\n.table-cell-sticky-6 {\n  left: 467px;\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  background-color: #0B0B0B; /* Explicit opaque background */\n  box-shadow: 6px 0 12px rgba(0, 0, 0, 0.3); /* Stronger shadow for last sticky column */\n}\n\n/* Fix background for even/odd rows - fully opaque */\n.table-row-even .table-cell-sticky-0,\n.table-row-even .table-cell-sticky-1,\n.table-row-even .table-cell-sticky-2,\n.table-row-even .table-cell-sticky-3,\n.table-row-even .table-cell-sticky-4,\n.table-row-even .table-cell-sticky-5,\n.table-row-even .table-cell-sticky-6 {\n  background-color: #1E1E1E !important; /* Fully opaque surface color for even rows */\n}\n\n.table-row-odd .table-cell-sticky-0,\n.table-row-odd .table-cell-sticky-1,\n.table-row-odd .table-cell-sticky-2,\n.table-row-odd .table-cell-sticky-3,\n.table-row-odd .table-cell-sticky-4,\n.table-row-odd .table-cell-sticky-5,\n.table-row-odd .table-cell-sticky-6 {\n  background-color: #0B0B0B !important; /* Fully opaque background color for odd rows */\n}\n\n/* Ensure sticky cells maintain background on hover */\n.table-row-even:hover .table-cell-sticky-0,\n.table-row-even:hover .table-cell-sticky-1,\n.table-row-even:hover .table-cell-sticky-2,\n.table-row-even:hover .table-cell-sticky-3,\n.table-row-even:hover .table-cell-sticky-4,\n.table-row-even:hover .table-cell-sticky-5,\n.table-row-even:hover .table-cell-sticky-6 {\n  background-color: #1a3526 !important; /* Subtle green tint on surface color */\n}\n\n.table-row-odd:hover .table-cell-sticky-0,\n.table-row-odd:hover .table-cell-sticky-1,\n.table-row-odd:hover .table-cell-sticky-2,\n.table-row-odd:hover .table-cell-sticky-3,\n.table-row-odd:hover .table-cell-sticky-4,\n.table-row-odd:hover .table-cell-sticky-5,\n.table-row-odd:hover .table-cell-sticky-6 {\n  background-color: #0f2419 !important; /* Subtle green tint on background color */\n}\n\n/* Regular row hover with same green tint */\n.table-row-even:hover {\n  background-color: #1a3526 !important;\n}\n\n.table-row-odd:hover {\n  background-color: #0f2419 !important;\n}\n\n/* Favorited row subtle accent */\n.table-row-favorited {\n  box-shadow: inset 3px 0 0 0 #facc15;\n}\n\n/* Number formatting */\n.table-cell-number {\n  @apply text-right;\n  font-variant-numeric: tabular-nums;\n}\n\n.table-cell-positive {\n  @apply text-green-400;\n}\n\n.table-cell-negative {\n  @apply text-red-400;\n}\n\n.table-row-even {\n  @apply border-t border-muted bg-surface/50 transition;\n}\n\n.table-row-odd {\n  @apply border-t border-muted bg-background transition;\n}\n\n.table-row-hover {\n  @apply hover:bg-accent/20;\n}\n\n.table-cell {\n  @apply px-4 py-2 whitespace-nowrap text-text;\n}\n\n/* === Tabs === */\n.tab-button {\n  @apply px-3 py-1 rounded text-sm font-medium transition-all duration-200 border;\n  background-color: #1f2937; /* gray-800 like Add to Queue button */\n  color: #b0b0b0; /* text-secondary */\n  border-color: #333;\n}\n\n.tab-selected {\n  background-color: #218aff !important; /* Blue like active/hover state */\n  color: #ffffff !important; /* White text */\n  border-color: #218aff !important;\n}\n\n.tab-unselected {\n  background-color: #1f2937; /* gray-800 default */\n  color: #b0b0b0; /* text-secondary */\n  border-color: #333;\n}\n\n.tab-unselected:hover {\n  background-color: #218aff; /* Blue on hover */\n  color: #ffffff; /* White text on hover */\n  border-color: #218aff;\n}\n\n\n/* === Spotify Theme Additions === */\n\n.btn-green {\n  @apply bg-[#1DB954] hover:bg-[#1ed760] text-black px-3 py-1 rounded text-xs;\n}\n\n.btn-dark {\n  @apply bg-[#404040] hover:bg-[#555] text-white px-3 py-1 rounded text-xs;\n}\n\n.btn-danger {\n  @apply bg-[#FF4C4C] hover:bg-[#FF5555] text-white px-3 py-1 rounded text-xs;\n}\n\n.card-dark {\n  @apply rounded-xl p-4 shadow-md bg-[#282828] text-white border border-[#1db954]/40 hover:shadow-lg transition-shadow;\n}\n\n.modal-dark {\n  @apply bg-[#121212] border border-[#1DB954] text-white p-6 rounded-xl shadow-xl;\n}\n\n/* === Animations === */\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fade-in 0.3s ease-out;\n}\n\n/* === Share Preview Modal === */\n\n.share-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.share-modal-content {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 12px;\n  max-width: 900px;\n  max-height: 90vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.share-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #333;\n}\n\n.share-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.share-modal-close {\n  background: transparent;\n  border: none;\n  color: #888;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.share-modal-close:hover {\n  color: #fff;\n  background: #333;\n}\n\n.share-preview-wrapper {\n  flex: 1;\n  overflow: auto;\n  padding: 20px;\n  background: #121212;\n}\n\n/* Capture Container - The actual image that gets captured */\n.share-capture-container {\n  background: #0a0a0a;\n  padding: 20px;\n  border-radius: 8px;\n  min-width: auto;\n}\n\n/* Simulation Settings Header */\n.share-settings-header {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  border: 2px solid #218aff;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.share-settings-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #218aff;\n  letter-spacing: 1.5px;\n  margin-bottom: 6px;\n}\n\n.share-settings-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* Share Modal - Slider Visualization */\n.share-sliders-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.share-slider-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.share-slider-label {\n  font-size: 11px;\n  color: #888;\n  min-width: 100px;\n  text-transform: uppercase;\n  text-align: left;\n}\n\n.share-slider-track {\n  flex: 1;\n  height: 6px;\n  background: #333;\n  border-radius: 3px;\n  position: relative;\n}\n\n.share-slider-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #218aff, #1a6bc7);\n  border-radius: 3px;\n}\n\n.share-slider-thumb {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 14px;\n  height: 14px;\n  background: #218aff;\n  border: 2px solid #0a0a0a;\n  border-radius: 50%;\n}\n\n.share-slider-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #218aff;\n  min-width: 100px;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.share-slider-date {\n  font-size: 10px;\n  color: #666;\n  font-weight: 400;\n}\n\n/* Share Table */\n.share-table-wrapper {\n  overflow-x: auto;\n  margin-bottom: 20px;\n}\n\n.share-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.share-table-header {\n  background: #1a1a1a;\n  color: #888;\n  font-weight: 600;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  padding: 8px 6px;\n  text-align: center;\n  border-bottom: 2px solid #333;\n  white-space: normal;\n  min-width: 60px;\n  max-width: 90px;\n  line-height: 1.3;\n}\n\n.share-table-cell {\n  padding: 8px 6px;\n  color: #e0e0e0;\n  white-space: nowrap;\n  border-bottom: 1px solid #222;\n  text-align: center;\n  font-size: 12px;\n}\n\n.share-row-even {\n  background: #0f0f0f;\n}\n\n.share-row-odd {\n  background: #141414;\n}\n\n.share-value-positive {\n  color: #10b981 !important;\n  font-weight: 600;\n}\n\n.share-value-negative {\n  color: #ef4444 !important;\n  font-weight: 600;\n}\n\n.share-table-truncated {\n  text-align: center;\n  color: #666;\n  font-size: 12px;\n  padding: 12px;\n  border-top: 1px solid #222;\n}\n\n/* Grouped header band above scenario columns (heatmap-mode share) */\n.share-table-header-group {\n  background: #1a1a1a;\n  color: #888;\n  font-weight: 700;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  padding: 6px 6px;\n  text-align: center;\n  border-bottom: 1px solid #333;\n}\n\n.share-table-header-group-emphasis {\n  color: #218aff;\n  border-bottom-color: #218aff;\n}\n\n/* Multi-line Contract cell (overrides nowrap) */\n.share-table-cell-multiline {\n  white-space: normal;\n  text-align: left;\n  padding: 6px 8px;\n  line-height: 1.25;\n}\n\n.share-contract-line1 {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 12px;\n}\n\n.share-contract-line2 {\n  color: #b0b0b0;\n  font-size: 11px;\n  margin-top: 1px;\n}\n\n/* Subtitle under SIMULATION SETTINGS card (heatmap-mode share) */\n.share-settings-subtitle {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid #2a2a3e;\n  font-size: 11px;\n  color: #a0a0a0;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.share-settings-subtitle strong {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.share-settings-subtitle > div + div {\n  margin-top: 4px;\n}\n\n/* Branding Footer */\n.share-footer {\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid #333;\n}\n\n.share-footer-text {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.share-footer-brand {\n  font-size: 18px;\n  font-weight: 700;\n  color: #218aff;\n  letter-spacing: 0.5px;\n}\n\n/* Modal Action Buttons */\n.share-modal-actions {\n  display: flex;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #333;\n  background: #1a1a1a;\n}\n\n.share-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.share-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.share-btn-primary {\n  background: #218aff;\n  color: #ffffff;\n}\n\n.share-btn-primary:hover:not(:disabled) {\n  background: #1a73e8;\n}\n\n.share-btn-secondary {\n  background: #333;\n  color: #ffffff;\n  border: 1px solid #444;\n}\n\n.share-btn-secondary:hover:not(:disabled) {\n  background: #444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
